import { render, staticRenderFns } from "./TabAccountDetails.vue?vue&type=template&id=70856183&scoped=true&"
import script from "./TabAccountDetails.vue?vue&type=script&lang=js&"
export * from "./TabAccountDetails.vue?vue&type=script&lang=js&"
import style0 from "./TabAccountDetails.vue?vue&type=style&index=0&id=70856183&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70856183",
  null
  
)

export default component.exports